if (!customElements.get('bowtie-carousel')) {
  customElements.define('bowtie-carousel', class extends HTMLElement {
    constructor() {
      super();
      this.slides = Array.from(this.querySelectorAll('.custom-featured-item'));
      this.prevBtn = this.querySelector('.bowtie-prev');
      this.nextBtn = this.querySelector('.bowtie-next');
      this.currentIndex = 0;
      this.visibleCount = 4; // Always 4 on desktop

      // Hide arrows if there are 4 or fewer posts
      if (this.slides.length <= this.visibleCount) {
        if(this.prevBtn) this.prevBtn.style.display = 'none';
        if(this.nextBtn) this.nextBtn.style.display = 'none';
      }

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.slide('prev'));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.slide('next'));

      this.update();
    }

    slide(direction) {
      if (direction === 'next' && this.currentIndex < this.slides.length - this.visibleCount) {
        this.currentIndex++;
      } else if (direction === 'prev' && this.currentIndex > 0) {
        this.currentIndex--;
      }
      this.update();
    }

    update() {
      this.slides.forEach((slide, index) => {
        // Reset classes
        slide.classList.remove('is-active', 'is-small', 'is-large');

        // If slide is inside the current 4-item window
        if (index >= this.currentIndex && index < this.currentIndex + this.visibleCount) {
          slide.classList.add('is-active');

          // Determine if it should be an outer (small) or inner (large) card based on its dynamic position
          if (index === this.currentIndex || index === this.currentIndex + 3) {
            slide.classList.add('is-small');
          } else {
            slide.classList.add('is-large');
          }
        }
      });

      // Disable arrows at the edges
      if (this.prevBtn) this.prevBtn.disabled = this.currentIndex === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.currentIndex >= this.slides.length - this.visibleCount;
    }
  });
}